interface DropdownItemProps {
  children: React.ReactNode
  href?: string
  onClick?: () => void
  slot?: string
}

export default function DropdownItem({
 children, href, onClick, slot 
}: DropdownItemProps) {
  const baseClasses = "block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
  
  if (href) {
    return (
      <a href={href} className={baseClasses}>
        {children}
      </a>
    )
  }
  
  return (
    <div 
      className={`${baseClasses} cursor-pointer`}
      onClick={onClick}
      data-slot={slot}
    >
      {children}
    </div>
  )
} 